import { TApplicationState } from '../../types/redux';

export function getNewbuildingId(state: TApplicationState) {
  const {
    newbuilding: { id },
  } = state;

  return id;
}
